import global from 'global';

import Bridge from './Bridge';
import * as webBridge from '../WebBridge';

/**
 * @param resolvers
 *
 * @returns Bridge
 */
export const createInstance = resolvers => new Bridge(resolvers);

const instance = new Bridge([
  /**
   * Use tulipNativeBridge provided by Web App
   */
  webBridge.resolve,

  /**
   * Use tulipNativeBridge provided by Mobile App
   */
  async () => global.tulipNativeBridge,
]);

export default instance;



// WEBPACK FOOTER //
// ./src/Bridge/index.js